import { useSetAtom } from 'jotai';
import { makeStyles } from '@material-ui/styles';

import { Text, MainButton, Clock } from '@bizzabo/design-system';
import { UserPreview } from '@bizzabo/entities';

import useDeclineMeeting from '../hooks/useDeclineMeeting';
import { MeetingsToolsParamsAtom } from '../../../appState/meetings/atoms';
import { MeetingsToolsParamsType } from '../../../appState/meetings/types';
import { ScheduledMeeting } from '../types';
import useTypeTracking from '../../../analytics';

type Props = {
    eventId: number;
    meeting: ScheduledMeeting;
    otherAttendee: UserPreview;
};

const ZeroAvailableTimesForInvitation: React.FC<Props> = ({ eventId, meeting, otherAttendee }) => {
    const classes = useStyles();
    const declineMeeting = useDeclineMeeting();
    const setMeetingsToolsParamsAtom = useSetAtom(MeetingsToolsParamsAtom);
    const { trackClickEvent } = useTypeTracking();

    const handleClick = () => {
        declineMeeting.mutate({ eventId, meetingId: meeting.id });
        setMeetingsToolsParamsAtom({
            type: MeetingsToolsParamsType.OpenWizard,
            otherAttendeeId: otherAttendee.userProfileId,
        });
        trackClickEvent({ subCategory: 'RESCHEDULE_UNAVAILABLE_MEETING' });
    };

    return (
        <div className={classes.container}>
            <Clock />
            <Text variant="t61" className={classes.text}>
                It looks like the meeting host is no longer available at that time. Please send them
                a new meeting invite in a time suitable for both of you.
            </Text>
            <MainButton variant="fillPrimary" className={classes.btnSettings} onClick={handleClick}>
                Reschedule meeting
            </MainButton>
        </div>
    );
};

const useStyles = makeStyles(
    theme => ({
        container: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            paddingTop: '12vh',
            [theme.breakpoints.up('sm')]: {
                paddingTop: '20vh',
            },
        },
        text: {
            margin: '16px 0 20px',
            textAlign: 'center',
            color: theme.customization.background.G10,
        },
        btnSettings: {
            ...theme.typography.t80,
            height: 24,
            padding: '0 13px',
        },
    }),
    { classNamePrefix: ZeroAvailableTimesForInvitation.name }
);

export default ZeroAvailableTimesForInvitation;
